import { Card, Grid, Typography } from '@material-ui/core'
import makeStyles from '@material-ui/core/styles/makeStyles'
import React from 'react'

import { ArticleLarge } from '../components/common/Layout'

const useStyles = makeStyles(theme => ({
  image: {
    width: '100%',
  },
  messageContainer: {
    marginTop: '32px',
    paddingLeft: '32px',
    [theme.breakpoints.down('xs')]: {
      marginTop: '8px',
      paddingLeft: '8px',
    },
  },
}))

const PageMaintenance = () => {
  const classes = useStyles()
  return (
    <ArticleLarge>
      <Card>
        <Grid container>
          <Grid item sm={5} xs={12}>
            <img
              alt="503 Page Under Maintenance"
              className={classes.image}
              src="https://images.foodsby.com/conweb/cooking.jpg"
            />
          </Grid>
          <Grid item sm={7} xs={12}>
            <div className={classes.messageContainer}>
              <Typography variant="h3">This page is temporarily unavailable.</Typography>
              <Typography>
                The server is currently under maintenance. Please try again later.
              </Typography>
            </div>
          </Grid>
        </Grid>
      </Card>
    </ArticleLarge>
  )
}

export default PageMaintenance
